import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "shift-being-created-container" }
const _hoisted_2 = { class: "mb-8 text-2xl font-bold" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "text-2xl cp-icon-plus" }, null, -1)
const _hoisted_4 = { class: "w-fit" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center truncate" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "px-1" }, "~", -1)
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_BaseIcon = _resolveComponent("BaseIcon")
  const _component_Table = _resolveComponent("Table")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('shiftCreation')), 1),
    _createVNode(_component_Button, {
      class: "mb-4",
      onClick: _ctx.onOpenShiftPlanCreateForm
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createTextVNode(" " + _toDisplayString(_ctx.t('signUp')), 1)
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Table, {
        headers: _ctx.membersToSubmittedHeaders,
        data: _ctx.shiftPlanList || [],
        showPagination: true,
        "record-total": _ctx.pagination.total,
        "items-per-pages": _ctx.pagination.per_page,
        currentPage: _ctx.shiftPlanSearchParams.page,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_ctx.shiftPlanSearchParams.page = $event)),
        onOnChangePage: _ctx.onChangePage
      }, {
        "data-shift_plan_no": _withCtx(({ index }) => [
          _createVNode("div", null, _toDisplayString(_ctx.shiftPlanList.length - index), 1)
        ]),
        "data-total_shift_employee": _withCtx(({ item }) => [
          _createVNode("div", _hoisted_5, _toDisplayString(item) + _toDisplayString(_ctx.t('person')), 1)
        ]),
        "data-date": _withCtx(({ dataRow }) => [
          _createVNode("div", _hoisted_6, [
            _createVNode("span", null, _toDisplayString(_ctx.formatTimeDate(
                  dataRow.shift_register_start_date,
                  'YYYY/MM/DD(dd)'
                )), 1),
            _hoisted_7,
            _createVNode("span", null, _toDisplayString(_ctx.formatTimeDate(
                  dataRow.shift_register_end_date,
                  'YYYY/MM/DD(dd)'
                )), 1)
          ])
        ]),
        "data-shift_plan_process_import_status": _withCtx(({ item }) => [
          _createVNode("div", {
            style: {
              background: _ctx.shiftPlanProcessImportStatusList[item].color,
            },
            class: "w-2 h-2 rounded-full mr-2"
          }, null, 4),
          _createVNode("div", _hoisted_8, _toDisplayString(_ctx.shiftPlanProcessImportStatusList[item].text), 1)
        ]),
        "data-edit": _withCtx(({ dataRow }) => [
          _withDirectives(_createVNode("div", _hoisted_9, [
            _createVNode(_component_BaseIcon, {
              name: "pencil-line",
              class: "cursor-pointer",
              onClick: ($event: any) => (_ctx.goToShiftPlanDetail(dataRow))
            }, null, 8, ["onClick"])
          ], 512), [
            [_directive_tooltip, _ctx.t('actionEdit')]
          ])
        ]),
        "data-delete": _withCtx(({ dataRow }) => [
          _withDirectives(_createVNode("div", null, [
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_BaseIcon, {
                name: "trash",
                class: "cursor-pointer",
                onClick: ($event: any) => (_ctx.openDeleteShiftPlanConfirm(dataRow))
              }, null, 8, ["onClick"])
            ])
          ], 512), [
            [_directive_tooltip, _ctx.t('actionDelete')]
          ])
        ]),
        _: 1
      }, 8, ["headers", "data", "record-total", "items-per-pages", "currentPage", "onOnChangePage"])
    ])
  ]))
}